var Backbone = require('backbone');
var SubtitleScope = require('./subtitle');

var MovieModel = Backbone.Model.extend({
	defaults: {
		title: null,
		videoSrc: null,
		frameRate: null,
		currentLanguageId: null,
		position : null,
		movieId: null,
		availableLanguages: [],
		captionLastUpdate: 'Never',
		subtitle: new SubtitleScope.Collection()
	}
});

module.exports = MovieModel;


// WEBPACK FOOTER //
// ./app/scopes/movie.js